import type { GalleryEvent } from 'Services/analytics/events/galleryEventsRedesign/types';

import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../../analytics.const';

const { GALLERY } = ANALYTICS_CATEGORIES;

export const triggerGalleryClosedEvent = ({ kind }: GalleryEvent): void => {
	const eventPayload = getSnowplowEventPayload({
		category: GALLERY,
		customData: { label: kind },
		name: 'dlr_hero_gallery_closed',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
